import { fg } from '@confluence/feature-gating';

// eslint-disable-next-line confluence-feature-gating/inline-usage
export const isOnboardingExpEnabled = (_shouldTrackExposureEvent: boolean = true): boolean => {
	return fg('cc_onboarding_experience');
};
